import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/AuthContext";
import Splash from "@/pages/Splash";
import Home from "@/pages/Home";
import Register from "@/pages/Register";
import Sponsor from "@/pages/Sponsor";
import Volunteer from "@/pages/Volunteer";
import SendNote from "@/pages/SendNote";
import Donate from "@/pages/Donate";
import DonateRedirect from "@/pages/DonateRedirect";
import DonateSuccess from "@/pages/DonateSuccess";
import FiveK from "@/pages/FiveK";
import FiveKRedirect from "@/pages/FiveKRedirect";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRoutes() {
    const location = useLocation();
    // Synchronous OAuth callback detection (prevents race conditions).
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Splash />} />
            <Route path="/home" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/sponsor" element={<Sponsor />} />
            <Route path="/volunteer" element={<Volunteer />} />
            <Route path="/send-note" element={<SendNote />} />
            <Route path="/donate" element={<DonateRedirect />} />
            <Route path="/donate/legacy" element={<Donate />} />
            <Route path="/donate/success" element={<DonateSuccess />} />
            <Route path="/5k-run" element={<FiveKRedirect />} />
            <Route path="/5k-run/legacy" element={<FiveK />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/callback" element={<AuthCallback />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
